import { Controller } from "@hotwired/stimulus"

// AdminMessageFormController - Toggle form fields based on broadcast mode
// Used in: admin_panel/admin_messages/new.html.erb
//
// Features:
// - Broadcast mode: hides user selection (sends to all users)
// - Individual mode: shows user selection (sends to specific user)
export default class extends Controller {
  static targets = [
    "broadcast",
    "userSection"
  ]

  connect() {
    // Initialize form state on load
    this.toggleBroadcast()
  }

  toggleBroadcast() {
    const isBroadcast = this.broadcastTarget.checked

    if (isBroadcast) {
      // Broadcast mode: hide user selection
      this.userSectionTarget.classList.add("hidden")
    } else {
      // Individual user mode: show user selection
      this.userSectionTarget.classList.remove("hidden")
    }
  }
}
